module.exports = {"130803001":"元宝山街道","130803002":"钢城街道","130803003":"秀水街道","130803100":"双塔山镇","130803101":"滦河镇","130803102":"大庙镇","130803103":"偏桥子镇","130803200":"陈栅子乡","130803201":"西地满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130803.json
// module id = 180
// module chunks = 0